export const CATS = ["süt satışı", "hayvan satışı", "yem", "işçilik", "ilaç", "veteriner", "elektrik/su", "diğer"];
export const PARTY_TYPES = ["tedarikçi", "personel", "fatura", "müşteri", "banka", "diğer"];
export const PAYMENT_TYPES = ["maaş", "sigorta", "prim", "avans", "diğer"];
export const LEAVE_REASONS = ["yıllık izin", "hastalık", "mazeret", "doğum", "ücretsiz izin"];
export const MONTHS_TR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
export function today() { return new Date().toISOString().slice(0, 10); }
export function fmt(v) { return Number(v || 0).toLocaleString("tr-TR"); }
